import { forwardRef } from "react";
import "./StatusContent.scss";
import StatusIcon from "../utils/StatusIcon";
import { cn } from "../../lib/utils";

const StatusContent = forwardRef(
	(
		{ className = "", listStatuses, onToggleStatus, onToggleAllStatus, selectedStatues, readOnly },
		ref
	) => {
		return (
			<div ref={ref} className={`main_list_status_download_component ${className}`}>
				<div className="item_status">
					<div className="left_content">
						<div className={cn("check_landing only_toggle", readOnly && "opacity-70")}>
							<input
								onChange={onToggleAllStatus}
								checked={selectedStatues?.length === listStatuses.length}
								type="checkbox"
								id={"select-all-status"}
								disabled={readOnly}
							/>
							<label htmlFor="select-all-status" className="icon">
								<span className="sr-only">Seleziona tutti gli stati</span>
							</label>
						</div>

						<label htmlFor="select-all-status" className="main_desc">
							<div className="title">Seleziona tutto</div>
							<div className="desc">Seleziona tutti gli stati delle linee d'azione</div>
						</label>
					</div>
				</div>
				{listStatuses.map((status, i) => (
					<div className="item_status" key={i}>
						<div className="left_content">
							<div className={cn("check_landing only_toggle", readOnly && "opacity-70")}>
								<input
									onChange={() => onToggleStatus(status.id)}
									checked={selectedStatues?.includes(status.id)}
									type="checkbox"
									id={`status-${i}`}
									disabled={readOnly}
								/>
								<label htmlFor={`status-${i}`} className="icon">
									<span className="sr-only">Seleziona lo stato {status.name}</span>
								</label>
							</div>

							<label htmlFor={`status-${i}`} className="main_desc">
								<div className="title">{status.name}</div>
								<div className="desc">{status.description}</div>
							</label>
						</div>

						<div className="right_content">
							<StatusIcon icon={status.icon} />
						</div>
					</div>
				))}
			</div>
		);
	}
);

export default StatusContent;
